import { createContext } from "react";
import { EAppTheme, IAppThemeContext } from "./types";
import { DEFAULT_APP_THEME } from "./config";

export const AppThemeContext = createContext<IAppThemeContext>({
  currentTheme: DEFAULT_APP_THEME,
  setAppTheme: (themeValue: EAppTheme) => {},
});
